<script lang="ts">
  import { Tab } from '$shared/components';
  import type { EntityTabOption } from '$shared/components/types';

  interface Props {
    activeTab?: string;
    tabs: ObjectType<any>[];
    hideTab?: boolean;
    options?: EntityTabOption;
    children?: import('svelte').Snippet;
    ontab?: (tab: any) => void;
  }

  let {
    activeTab = $bindable(''),
    tabs,
    hideTab = false,
    options = {},
    children,
    ontab
  }: Props = $props();

  const onClickTab = (tab): void => {
    activeTab = tab.id;
    ontab?.(tab);
  };
</script>

<div class="entity-tab">
  {#if !hideTab}
    <div class="tab">
      <Tab list={tabs} active={activeTab} onclick={onClickTab}>
        {#if options?.customRightAction?.component}
          <div class="tab-right-action">
            <options.customRightAction.component
              {...options.customRightAction.props}
            />
          </div>
        {/if}
      </Tab>
    </div>
  {/if}
  <div class="tab-container">
    {@render children?.()}
  </div>
</div>

<style>
  .entity-tab {
    margin-top: 32px;
  }
  .tab {
    margin-bottom: 24px;
  }
  .tab-right-action {
    flex: 1;
    display: inline-flex;
    justify-content: flex-end;
    padding-bottom: 16px;
  }
</style>
